module.exports = __webpack_public_path__ + "static/pic4-8cdaaf082f3830ed3fe390368adce624.png";